import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["check"]

  toggle(event) {
    this.checkTargets.forEach(checkbox => {
      checkbox.checked = event.target.checked
    })
  }
}
